"use client";

import { useMemo } from "react";
import { useTable } from "spacetimedb/react";
import { toast } from "sonner";
import { tables } from "@/module_bindings";
import { useRowTransitions } from "@/hooks/spacetime/use-row-transitions";
import type { Organization } from "@/types/organization";
import type { OrgTaxExemptionRow } from "@/lib/stdb-map";

/** Spec events #2/#3: org_tax_exemptions.status -> approved | rejected. */
export function TaxExemptionStatusToasts({
  organization,
}: {
  organization: Organization | null;
}) {
  const [rows, isReady] = useTable(tables.org_tax_exemptions);
  const orgRows = useMemo(
    () =>
      organization
        ? rows.filter(
            (row: OrgTaxExemptionRow) => row.organizationId === organization.id,
          )
        : [],
    [rows, organization],
  );

  useRowTransitions<OrgTaxExemptionRow>({
    rows: orgRows,
    isReady,
    getId: (row) => row.id,
    getState: (row) => row.status,
    resetKey: organization?.id ?? null,
    onTransition: ({ next, row }) => {
      if (next === "approved") {
        toast.success("Tax Exemption Approved", {
          id: `tax-exemption-${row.id}-approved`,
          description: "Checkout will no longer collect sales tax.",
        });
      } else if (next === "rejected") {
        toast.error("Tax Exemption Rejected", {
          id: `tax-exemption-${row.id}-rejected`,
          description: "See Sales Tax settings for details.",
        });
      }
    },
  });

  return null;
}
